import http from "./http";

/** 
 * Get result display setting 
 * 20240929
 * @param {string} verificationId
 * **/
export function getResultDisplaySettings(verificationId) {
  return http.get(`/verification/${verificationId}/result-settings`);
}

/** 
 * Get result display setting 
 * 20240929
 * @param {string} verificationId
 * @param {object} setting {waveform:{displayMode}, sParameter}
 * **/
export function saveResultDisplaySettings({ verificationId, setting }) {
  return http.post(`/verification/${verificationId}/result-settings`, setting);
}